import React, { createContext, useCallback, useContext, useState } from 'react';
import { AnimationType } from '../editor-property-panel/ui/contents/animation/animation-drag-data';

export interface AnimationDropPreviewState {
  // 애니메이션 타입
  animationType: AnimationType;
  // 애니메이션 이름
  name: string;
  // 대상 아이템 ID
  targetItemId: string;
  // 대상 트랙 인덱스
  trackIndex: number;
  // 드롭 가능 여부 (비디오/이미지만 가능)
  isAvailable: boolean;
  // 아이템 위치 정보
  itemLeft: number;
  itemWidth: number;
}

interface AnimationDropPreviewContextValue {
  previewState: AnimationDropPreviewState | null;
  setPreviewState: (state: AnimationDropPreviewState | null) => void;
}

const AnimationDropPreviewContext =
  createContext<AnimationDropPreviewContextValue | null>(null);

export const AnimationDropPreviewProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [previewState, setPreviewState] =
    useState<AnimationDropPreviewState | null>(null);

  const value = {
    previewState,
    setPreviewState: useCallback(
      (state: AnimationDropPreviewState | null) => setPreviewState(state),
      [],
    ),
  };

  return (
    <AnimationDropPreviewContext.Provider value={value}>
      {children}
    </AnimationDropPreviewContext.Provider>
  );
};

export const useAnimationDropPreview = () => {
  const ctx = useContext(AnimationDropPreviewContext);
  if (!ctx) {
    throw new Error(
      'useAnimationDropPreview must be used within AnimationDropPreviewProvider',
    );
  }
  return ctx;
};
